import { render, staticRenderFns } from "./GoodsEditForm.vue?vue&type=template&id=7313a812&scoped=true"
import script from "./GoodsEditForm.vue?vue&type=script&lang=js"
export * from "./GoodsEditForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsEditForm.vue?vue&type=style&index=0&id=7313a812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313a812",
  null
  
)

export default component.exports